module.exports = __webpack_public_path__ + "static/img/header.33aeafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/header.png
// module id = omgv
// module chunks = 7